import { RoutePaths } from '@interfaces/routePaths'
import { Base } from '@views/Tasks/Base'
import { BaseLayout } from '../BaseLayout'

export const TASKS_PATHS = [
  {
    path: RoutePaths.TASKS,
    element: <BaseLayout />,
    children: [
      {
        index: true,
        element: <Base />,
      },
    ],
  },
]
